import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchMeetingTopics } from "./api"

export function useMeetingTopics(options: { enabled?: boolean } = {}) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["meeting-topics"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchMeetingTopics(context)
    },
    enabled: options.enabled ?? true,
  })
}
